import { isNil, sortBy, uniq, uniqBy } from "lodash";
import { documentState, momentKey } from "utils/helpers/documentTemplates";
import { searchable } from "utils/helpers/text";

export const EMPTY_FILTERS = { type: null, state: null, product: null };

const usagesOf = (template) => template?.usages || [];

const matchesSearch = (template, search) =>
  searchable(template.name).includes(searchable(search));

const matchesType = (template, type) =>
  isNil(type) || usagesOf(template).some((usage) => usage.type === type);

const matchesProduct = (template, product) =>
  isNil(product) ||
  usagesOf(template).some((usage) => usage.insurancePlanId === product);

const matchesState = (template, state) =>
  isNil(state) || documentState(template) === state;

export const filterTemplates = (templates, { search, filters }) =>
  templates.filter(
    (template) =>
      matchesSearch(template, search) &&
      matchesType(template, filters.type) &&
      matchesState(template, filters.state) &&
      matchesProduct(template, filters.product),
  );

export const activeFilterCount = (filters) =>
  Object.values(filters).filter((value) => !isNil(value)).length;

export const productOptions = (templates) =>
  sortBy(
    uniqBy(templates.flatMap(usagesOf), "insurancePlanId").map(
      ({ insurancePlanId, insurancePlanName }) => ({
        value: insurancePlanId,
        label: insurancePlanName || insurancePlanId,
      }),
    ),
    (option) => searchable(option.label),
  );

export const usedInProducts = (template, t) =>
  uniq(
    usagesOf(template).map(({ insurancePlanName, insurancePlanId, area }) =>
      t("LIST.USED_IN_ITEM", {
        product: insurancePlanName || insurancePlanId,
        moment: t(`MOMENTS.${momentKey(area)}`),
      }),
    ),
  ).join(", ");
